import React from "react";
import TextoNosotros from "../../components/TextoNosotros/TextoNosotros.js";
import ServiciosNosotros from "../../components/ServiciosNosotros/ServiciosNosotros.js";
import Footer from "../../components/Footer/Footer.js";
import Portada from "../../components/Portada/Portada";
import FilosofiaCorporativa from "../../components/FilosofiaCorporativa/FilosofiaCorporativa.js";



function Nosotros() {
  return (
    <div>
      <Portada titulo="Nosotros" />
      <FilosofiaCorporativa />
      <TextoNosotros />
      <ServiciosNosotros />
      <Footer />
    </div>
  );
}

export default Nosotros;
